import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Bookmark } from "lucide-react";
import { useToast } from "./ui/use-toast";

export default function SaveScheduleButton({ 
  scheduleId, 
  isSaved,
  onToggleSave,
  variant = "outline",
  size = "sm",
  showText = true,
  className = ""
}) {
  const [saved, setSaved] = useState(isSaved);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  // Update local state when props change
  useEffect(() => {
    setSaved(isSaved);
  }, [isSaved]);

  const handleToggleSave = async () => {
    if (!scheduleId) {
      toast({
        title: "Error",
        description: "No schedule selected",
        variant: "destructive",
      });
      return;
    }

    setLoading(true);
    try {
      const newSavedState = !saved;
      const success = await onToggleSave(scheduleId, newSavedState);
      
      if (success) {
        setSaved(newSavedState);
      }
    } catch (error) {
      console.error("Error toggling save state:", error);
      toast({
        title: "Error",
        description: "Failed to update saved status",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleToggleSave}
      disabled={loading}
      className={`${className} ${saved ? "text-gray-400 hover:text-gray-500" : ""}`}
      aria-label={saved ? "Unsave schedule" : "Save schedule"}
    >
      <Bookmark 
        className={`h-4 w-4 ${saved ? "fill-current text-gray-400" : ""} ${showText ? "mr-2" : ""}`} 
      />
      {showText && (saved ? "Saved" : "Save")}
    </Button>
  );
} 